module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("followUp记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserName", $$v)
      },
      expression: "queryParam.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.studyNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyNickname", $$v)
      },
      expression: "queryParam.studyNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生手机"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "traceStatus"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeFollow
    },
    model: {
      value: (_vm.queryParam.traceStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "traceStatus", $$v)
      },
      expression: "queryParam.traceStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("高跟进")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("跟进中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("跟进低")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("无意向")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("多次联系不到")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "followUp选项",
      "prop": "traceItem"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.queryParam.traceItem),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "traceItem", $$v)
      },
      expression: "queryParam.traceItem"
    }
  }, _vm._l((_vm.followList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "user",
      "label": "处理人部门："
    }
  }, [_c('Select', {
    model: {
      value: (_vm.queryParam.teamType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "teamType", $$v)
      },
      expression: "queryParam.teamType"
    }
  }, _vm._l((_vm.adviserGroupList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "处理人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.modifierName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "modifierName", $$v)
      },
      expression: "queryParam.modifierName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "添加时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.schangeDate
    },
    model: {
      value: (_vm.snextDate),
      callback: function($$v) {
        _vm.snextDate = $$v
      },
      expression: "snextDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.echangeDate
    },
    model: {
      value: (_vm.enextDate),
      callback: function($$v) {
        _vm.enextDate = $$v
      },
      expression: "enextDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/saleTrace/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15d1310a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/FollowUpList.vue
// module id = 1660
// module chunks = 8